import React, { useState, useEffect } from 'react';
import '../styles/Ceo Page/Ceo.css';

const DEFAULT_FOUNDER = {
  name: "Dr. Melvin Mathew",
  credentials: "Founder & Chief Dental Surgeon | BDS, FAGE",
  biography: "Dr. Melvin Mathew, the visionary founder of Sky Dental Hospital, Kanhangad, is a highly skilled and compassionate dental professional dedicated to delivering world-class oral healthcare. With years of expertise in advanced dentistry, he leads his team with a commitment to innovation, patient comfort, and excellence in community dental care.",
  quote: "Our mission is — A smile is an inexpensive way to change your look.",
  image_url: "/images/Ceo/Dr Melvin mathew.png"
};

function CEOSection() {
  const [founder, setFounder] = useState(DEFAULT_FOUNDER);

  useEffect(() => {
    fetch('/api/founder')
      .then(res => {
        if (res.ok) return res.json();
        throw new Error('API request failed');
      })
      .then(data => {
        if (data) {
          setFounder(data);
        }
      })
      .catch(err => {
        console.warn('Could not load dynamic founder details, using local fallbacks:', err.message);
      });
  }, []);

  // Helper to split and highlight the name beautifully (e.g. Dr. [Melvin] Mathew)
  const renderHighlightedName = (fullName) => {
    if (!fullName) return '';
    const parts = fullName.split(' ');
    
    if (parts.length >= 3) {
      // e.g. "Dr. Melvin Mathew" -> "Dr. [Melvin] Mathew"
      return (
        <>
          {parts[0]} <span className="ceo-highlight">{parts[1]}</span> {parts.slice(2).join(' ')}
        </>
      );
    } else if (parts.length === 2) {
      // e.g. "Melvin Mathew" -> "[Melvin] Mathew"
      return (
        <>
          <span className="ceo-highlight">{parts[0]}</span> {parts[1]}
        </>
      );
    }
    
    return fullName;
  };

  return (
    <section className="ceo-section">
      <h2 className="ceo-heading">Meet Our Founder</h2>

      <div className="ceo-inner">

        {/* Photo */}
        <div className="ceo-photo-wrapper">
          <img
            src={founder.image_url}
            alt={`${founder.name} - ${founder.credentials}`}
            className="ceo-photo"
            loading="lazy"
          />
        </div>

        {/* Content */}
        <div className="ceo-left">
          <h2 className="ceo-name">
            {renderHighlightedName(founder.name)}
          </h2>

          <p className="ceo-title-tag">
            {founder.credentials}
          </p>

          <p className="ceo-desc">
            {founder.biography}
          </p>

          <div className="ceo-quote">
            <svg
              className="ceo-quote-icon"
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="#088395"
              opacity="0.6"
            >
              <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
            </svg>
            <p className="ceo-quote-text">
              {founder.quote}
            </p>
          </div>

          <a href="#team" className="ceo-btn">
            Meet Our Team
            <span className="ceo-btn-arrow">
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </span>
          </a>
        </div>

      </div>
    </section>
  );
}

export default CEOSection;